import { motion } from "framer-motion";
import { ShoppingBag, Bike, TreePalm, Star } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const SERVICES = [
  {
    icon: ShoppingBag,
    title: "Asporto",
    text: "Ordina al telefono o su WhatsApp e passa a ritirare: la tua pizza è pronta in pochi minuti.",
  },
  {
    icon: Bike,
    title: "Domicilio",
    text: "Consegniamo a casa tua a Fiumefreddo e nei comuni limitrofi. Solo € 0,50 a pizza.",
  },
  {
    icon: TreePalm,
    title: "Tavoli all'Aperto",
    text: "Formula libera: ordini al banco e ti accomodi dove preferisci, senza servizio al tavolo. Solo tu, la pizza e il cielo siciliano.",
  },
];

const RATINGS = [
  { source: "Google", score: "4.6", max: "/5", count: "61 recensioni" },
  { source: "TheFork", score: "8.9", max: "/10", count: "1043 recensioni" },
  { source: "Facebook", score: "5.0", max: "/5", count: "53 recensioni" },
];

export default function Services() {
  return (
    <section id="servizi" data-testid="services-section" className="relative py-28 sm:py-40 bg-ink">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="text-[11px] tracking-[0.45em] uppercase text-terra"
        >
          I Servizi
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1, ease: EASE }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream mt-4"
        >
          Come vuoi, <span className="italic text-gold">dove vuoi.</span>
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 mt-16">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`service-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: EASE }}
              className="group bg-ink p-10 sm:p-12 hover:bg-coal transition-colors duration-500"
            >
              <s.icon size={30} strokeWidth={1.2} className="text-gold group-hover:text-terra transition-colors duration-500" />
              <h3 className="font-display text-2xl text-cream mt-6">{s.title}</h3>
              <p className="text-cream/50 text-sm leading-relaxed mt-4">{s.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
          data-testid="ratings-strip"
          className="mt-24 flex flex-col sm:flex-row items-stretch justify-between gap-10 border-y border-white/10 py-12"
        >
          {RATINGS.map((r) => (
            <div key={r.source} data-testid={`rating-${r.source.toLowerCase()}`} className="flex-1 text-center sm:text-left">
              <div className="flex items-center justify-center sm:justify-start gap-2">
                <Star size={16} className="text-gold fill-gold" />
                <span className="text-[11px] tracking-[0.35em] uppercase text-cream/50">{r.source}</span>
              </div>
              <div className="font-display text-5xl sm:text-6xl text-cream mt-3">
                {r.score}
                <span className="text-xl text-cream/40">{r.max}</span>
              </div>
              <p className="text-cream/40 text-xs tracking-[0.2em] uppercase mt-2">{r.count}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
